"use client";

import { useState, useEffect } from "react";
import { LeagueService } from "@/services/leagueService";

export default function useAllLeagues() {
  const [leagues, setLeagues] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchLeagues = async () => {
      try {
        setLoading(true);

        const data = await LeagueService.getAllLeagues({
          fields: "id,logo,name,nameVN,isHot,country,countryLogo,countryId",
        });

        setLeagues(data);
      } catch (error) {
        console.error("Error fetching all leagues:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchLeagues();
  }, []);

  return {
    leagues,
    loading,
  };
}
